import styled from 'styled-components';

export const FormOuter = styled.div``;

export const Wrapper = styled.div<{ padding: string }>`
  width: 100%;
  padding: ${({ padding }) => padding};
`;

export const FieldSelectWrapper = styled.div`
  width: 100%;
`;

export const AddButton = styled.button`
  background: linear-gradient(180deg, #ffffff 0.69%, #fbfbfb 100%);
  border-radius: 8px;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2), 0px 20px 32px rgba(0, 0, 0, 0.2),
    0px 0px 40px rgba(0, 0, 0, 0.16);
  height: 80px;
  width: 128px;
  border: none;
  position: absolute;
  z-index: 2;
  left: 32px;
  bottom: 40px;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 10px;
  letter-spacing: 0.24px;
  line-height: 16px;
  color: var(--colorUIBlue);
  cursor: pointer;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;

  svg {
    margin-top: 2px;
  }

  &:hover,
  &:focus {
    outline: none;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.04), rgba(0, 0, 0, 0.04)),
      linear-gradient(180deg, #ffffff 0.69%, #fbfbfb 100%);
  }
`;

export const FormWrapper = styled.div`
  margin: -16px -8px 0;
  display: flex;
  flex-flow: row wrap;
`;

export const StorybookWrapper = styled.div`
  width: 500px;
`;
